export const EARLY_YEAR_RECRUITING_MAIL = 'EARLY_YEAR_RECRUITING_MAIL'
export const LAST_YEAR_RECRUITING_MAIL = 'LAST_YEAR_RECRUITING_MAIL'
export const INTERNSHIP_STUDENT_EVALUATION = 'INTERNSHIP_STUDENT_EVALUATION'
export const INTERNSHIP_IS_ACCEPTED = 'INTERNSHIP_IS_ACCEPTED'
export const ATTRACTIVITY_MODULE_TRACKING_REPORT = 'ATTRACTIVITY_MODULE_TRACKING_REPORT'
export const INTERNSHIP_COMPENSATION = 'INTERNSHIP_COMPENSATION'
export const INTERNSHIP_REQUEST_APPROVED = 'INTERNSHIP_REQUEST_APPROVED'
export const SCHOOL_PORTAL_REQUEST_ACKNOWLEDGED = 'SCHOOL_PORTAL_REQUEST_ACKNOWLEDGED'
export const SCHOOL_PORTAL_REQUEST_ACCEPTED = 'SCHOOL_PORTAL_REQUEST_ACCEPTED'
export const SCHOOL_PORTAL_REQUEST_REFUSED = 'SCHOOL_PORTAL_REQUEST_REFUSED'

export const Descriptions = Object.freeze({
  EARLY_YEAR_RECRUITING_MAIL: 'early_year_recruitement_email_description',
  LAST_YEAR_RECRUITING_MAIL: 'last_year_recruitement_email_description',
  INTERNSHIP_STUDENT_EVALUATION: 'student_evaluation_email_description',
  INTERNSHIP_IS_ACCEPTED: 'internship_acceptation_email_description',
  ATTRACTIVITY_MODULE_TRACKING_REPORT: 'attractivity_module_tracking_report_email_description',
  INTERNSHIP_COMPENSATION: 'internship_compensation_email_description',
  INTERNSHIP_REQUEST_APPROVED: 'internship_request_approved_email_description',
  SCHOOL_PORTAL_REQUEST_ACKNOWLEDGED: 'school_portal_request_acknowledged_email_description',
  SCHOOL_PORTAL_REQUEST_ACCEPTED: 'school_portal_request_accepted_email_description',
  SCHOOL_PORTAL_REQUEST_REFUSED: 'school_portal_request_refused_email_description'
})
